
// Access global firebase instance loaded via script tags in index.html
const firebase = (window as any).firebase;

// --- CẤU HÌNH API KEY ---
const FIREBASE_API_KEY = "AIzaSyDZkT4Jgr6IdUWKnDEQnkvb9IxCgN_mxME";

const firebaseConfig = {
  apiKey: FIREBASE_API_KEY, 
  authDomain: "writeseomasterai.firebaseapp.com",
  projectId: "writeseomasterai",
  storageBucket: "writeseomasterai.firebasestorage.app",
  messagingSenderId: "49205411276",
  appId: "1:49205411276:web:665ee6b9d71a657e883169",
  measurementId: "G-GMLPMG92LG" 
};

let app: any = null;
let auth: any = null;
let db: any = null;
let googleProvider: any = null;

const initFirebase = async () => {
  try {
    if (!firebase) {
      throw new Error("Firebase SDK not loaded");
    }

    app = !firebase.apps.length ? firebase.initializeApp(firebaseConfig) : firebase.app();
    auth = app.auth();
    db = app.firestore();
    
    // Đảm bảo phiên đăng nhập bền vững, không bị thoát khi lỗi UI xảy ra
    await auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

    googleProvider = new firebase.auth.GoogleAuthProvider();
    googleProvider.addScope('https://www.googleapis.com/auth/webmasters.readonly');
    
    console.log("✅ Firebase Initialized");
  } catch (e: any) {
    console.error("❌ Firebase Initialization Error:", e.message);
  }
};

initFirebase();

export { app, auth, db, googleProvider };
export default app;
